import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription, debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-cardapio-minishop-header',
  templateUrl: './cardapio-minishop-header.component.html',
  styleUrls: ['./cardapio-minishop-header.component.scss'],
})
export class CardapioMinishopHeaderComponent implements OnInit, OnDestroy {
  @Input() bannerUrl: string | null = null;
  @Input() logoUrl: string | null = null;
  @Input() nomeNegocio = '';

  @Output() buscar = new EventEmitter<string>();
  @Output() trocarBanner = new EventEmitter<void>();

  texts = {
    buscar_produtos: '',
    trocar_banner: '',
    favoritar: '',
    compartilhar: '',
  };

  private searchSubject = new Subject<string>();
  private langChangeSub!: Subscription;
  private searchSub!: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
    });

    this.searchSub = this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(termo => {
      this.buscar.emit(termo);
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) this.langChangeSub.unsubscribe();
    if (this.searchSub) this.searchSub.unsubscribe();
    this.searchSubject.complete();
  }

  onSearchInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.searchSubject.next(value);
  }

  private loadTranslations(): void {
    this.texts = {
      buscar_produtos: this.translate.instant('cardapio_minishop.header.buscar_produtos'),
      trocar_banner: this.translate.instant('cardapio_minishop.header.trocar_banner'),
      favoritar: this.translate.instant('cardapio_minishop.header.favoritar'),
      compartilhar: this.translate.instant('cardapio_minishop.header.compartilhar'),
    };
  }
}
